import React from 'react'
import assets from '../assets'
import Button from '../Components/Button'
import './index.css'
import Space from './Space'
import { motion } from "framer-motion"


const Hero = ({handleActivePopUp, variants}) => {
  return (
    <div className='hero relative flex vertCenter noevent' id='hero'>
        <img className='light1' src={assets.light.header1} alt="Lights" />
        <img className='light1' src={assets.light.header2} alt="Lights" />
        <img className='light3' src={assets.light.hero1} alt="Lights" />
        <img className='light4' src={assets.light.hero2} alt="Lights" />
        <Space />
        <div className="container-lg flex flexCol">
            <div className="textBlock flex flexCol">
                <motion.h1
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .5 }}
                viewport={{ once: true }}
                    >Build<br/>
                    Earn<br/>
                    Automate
                </motion.h1>
                <motion.h4
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .7 }}
                viewport={{ once: true }}
                >
                    Fast, fully open source & cross-chain compatible.
                </motion.h4>
                <Button link='#contact' text='Build now' build handleActivePopUp={handleActivePopUp} popData='build'/>
                <Button link='#contact' text='Apply White List Pre-Sale' handleActivePopUp={handleActivePopUp} popData='white' />
            </div>
        </div>
    </div>
  )
}

export default Hero